

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/CategoryMenu/Widget/index.tsx';
    import createController from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/CategoryMenu/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18n as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  import * as viewerApp from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/viewer.app.ts';
    var importedApp = viewerApp;

    var componentName = 'CategoryMenu';
    var projectName = 'communities-blog-ooi';
    var sentryConfig = {
      DSN: 'https://2062d0a4929b45348643784b5cb39c36@sentry.wixpress.com/1643',
      id: '2062d0a4929b45348643784b5cb39c36',
      projectName: 'communities-blog-ooi',
      teamName: 'blogas',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/components/CategoryMenu/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["wix-social-blog","ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"enabled":true,"icuEnabled":true,"defaultTranslationsPath":"/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"category-link.post-count":"({count, number})","empty-state.no-categories":"No categories yet.","aria-label.category-menu":"Category Menu","category-link.a11y-post-count":"{count, plural, one {# post} other {# posts}}","category-link.a11y-post-count-plural":"{count, number} posts","category-link.a11y-post-count_plural":"{count, number} posts","app-settings.main-tab":"Main","app-settings.display-tab":"Display","app-settings.layout-tab":"Layout","app-settings.design-tab":"Design","app-settings.support-tab":"Support","support-tab.links-divider":"Got a question?","support-tab.read-support-articles-link":"Read Support Articles","support-tab.get-involved-text":"Get involved. Ask questions, get answers and share your thoughts with other bloggers.","support-tab.blog-community-link":"Blog Community","main-tab.title":"Category Menu","main-tab.description":"Display your categories in a menu. Pick a layout, customize the look & more.","main-tab.manage-categories-button":"Manage Categories","main-tab.customize-design-button":"Customize Design","display-tab.show-all-posts-category-label":"Show \"All Posts\"","display-tab.show-post-count-label":"Show number of posts","display-tab.manage-categories-text":"To add and rearrange your categories, go to your Dashboard.","display-tab.manage-categories-button":"Manage Categories","display-tab.mobile.different-settings-label":"Enable mobile settings","tab.mobile.settings-toggle-info-text":"If disabled, your display settings for mobile are taken from desktop. Turn on these settings to customize how your category menu looks on mobile devices.","link-list-design-settings.text-color-label":"Font color","link-list-design-settings.text-font-and-color-label":"Font style & color","link-list-design-settings.background-color-label":"Background opacity & color","link-list-design-settings.separator-color-label":"Divider opacity & color","link-list-design-settings.separator-width-label":"Divider width","link-list-design-settings.border-color-label":"Border opacity & color","link-list-design-settings.border-width-label":"Border width","link-list-design-settings.corner-radius-label":"Corner radius","link-list-design-settings.default-state-tab":"Regular","link-list-design-settings.hover-state-tab":"Hover","link-list-layout-settings.text-alignment-label":"Text alignment","link-list-layout-settings.text-alignment-left":"Left","link-list-layout-settings.text-alignment-center":"Center","link-list-layout-settings.text-alignment-right":"Right","link-list-layout-settings.text-padding-horizontal-label":"Text side padding","link-list-layout-settings.text-padding-vertical-label":"Text top & bottom padding","support-tab.category-menu.about.title":"Customizing a category menu","support-tab.category-menu.about.description":"Categories are a great way to organize and structure your blog. It can also help your readers find the content they want quickly and easily.","support-tab.category-menu.about.read-more":"Read More","support-tab.category-menu.additional-article.creating-categories":"Creating blog categories","support-tab.category-menu.additional-article.deleting-categories":"Deleting blog categories","support-tab.technical-assistant.description":"Technical problems? Troubleshoot common errors and issues.","support-tab.technical-assistant.link-label":"Wix Technical Assistant","support-tab.faq.description":"Find answers in the Blog Community FAQ.","support-tab.faq.link-label":"Frequently Asked Questions","support-tab.customer-care.description":"Still having issues? Contact us for assistance.","support-tab.customer-care.link-label":"Contact Customer Care","support-tab.help-center.label":"Help Center","support-tab.help-center.all-articles":"See All Articles"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "14bcded7-0066-7c35-14d7-466cb3f09103";
    var componentId = "a0d7808c-0d7d-4a40-8cf0-911a9f0de96f";
    var localeDistPath = 'components/CategoryMenu/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = true;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/a28d066c8eec62f2/packages/communities-blog-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
